import { FlowIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  CreateLeadDefaults,
  CreateLeadModal
} from "shared/app/LeadsTableView/components/CreateLeadModal";
import { Button, ButtonVariant, Show } from "shared/components";

export const NoLeadsSlice = ({
  isCreateLeadModalOpen,
  hasHeaderTitle = false,
  setIsCreateLeadModalOpen,
  refetchLeads,
  createLeadDefaults
}: {
  isCreateLeadModalOpen: boolean;
  hasHeaderTitle?: boolean;
  setIsCreateLeadModalOpen: (isOpen: boolean) => void;
  refetchLeads: () => void;
  createLeadDefaults?: CreateLeadDefaults;
}) => {
  return (
    <>
      <div className="flex flex-col h-full">
        <Show if={hasHeaderTitle}>
          <h1 className="text-2xl font-bold text-content-1000">Leads</h1>
        </Show>
        <div className="flex flex-col flex-grow items-center justify-center">
          <div className="mb-6 w-[100px] h-[100px] bg-[#1C1D2205] rounded-full flex items-center justify-center">
            <HugeiconsIcon icon={FlowIcon} size={40} stroke="1.5px" />
          </div>
          <div className="space-y-2 text-center mb-6">
            <p className="text-base font-bold text-content-500">
              Leads will appear here
            </p>
            <p className="text-sm font-medium text-content-300">
              No leads yet. Create a lead to get started
            </p>
          </div>
          <Button
            variant={ButtonVariant.PRIMARY}
            onClick={() => setIsCreateLeadModalOpen(true)}
          >
            Create lead
          </Button>
        </div>
      </div>
      <CreateLeadModal
        open={isCreateLeadModalOpen}
        refetchLeads={refetchLeads}
        onClose={() => setIsCreateLeadModalOpen(false)}
        defaults={createLeadDefaults}
      />
    </>
  );
};
